import $ from 'jquery';
import { scrollToId } from './scrollTo';

export const init = () => {
	const $contactCardItems = $('.js-contact-card-item'),
		$stickySearchBox = $('.js-support-searchbox');

	if (!$contactCardItems.length || !$stickySearchBox.length) {
		return;
	}

	const $heroInput = $stickySearchBox.find("input:text[name='ico']");

	const API_URL = $stickySearchBox.data('api-url'),
		INVALID_FORMAT = $stickySearchBox.data('invalid-format'),
		EMPTY_FIELD = $stickySearchBox.data('empty-field'),
		INPUT_REGEX = /^(([a-zA-Z]*\d+)|(\d+\/\d+))$/;

	/**
	 * List of scenarios ordered by priority.
	 * The lower the index, the higher the scenario priority.
	 */
	const scenarioPriorityList = ['scenario3', 'scenario2', 'scenario1', 'scenario4'];

	/**
	 * Maps kindServiceCode to scenario
	 */
	const kindServiceCodeToScenarioMappings = {
		1: 'scenario1', // HZ
		2: 'scenario3', // HL
		3: 'scenario3', // TL
		4: 'scenario3', // NL
		7: 'scenario2', // 2L3
		8: 'scenario2', // BE
		9: 'scenario2', // BD
		10: 'scenario2', // BO
		11: 'scenario2', // BP
	};

	$stickySearchBox.on('submit', function (event) {
		event.preventDefault();

		const inputText = $heroInput.val().trim();

		if (!validateInput($heroInput, inputText)) {
			return;
		}

		const url = API_URL + inputText;

		hideAll();

		$.ajax({
			type: 'GET',
			url: url,
			contentType: 'text/plain',
		})
			.done(function (data) {
				processAPIResult(data);
				sendGTM(true);
			})
			.fail(function () {
				showScenarioCardList('scenario4');
				sendGTM(false);
			});
	});

	function processAPIResult(data) {
		if (!data || !data.Service) {
			// empty result, not a customer
			showScenarioCardList('scenario4');
			return;
		}

		const partners = mapPartnersToScenarios(data.Service);

		sortPartners(partners);

		// select the first partner that has a KAM
		let partner = partners.find((p) => p.service);

		// if no one has a KAM, take the first partner
		if (!partner) partner = partners[0];

		let scenario = partner.scenario;

		if (scenario !== 'scenario1' && partner.service) {
			// if has KAM, fill contact info
			const card = $('#scenario3 .contact-card__item:nth-of-type(2)');
			fillManagerContactInfo(card, partner.service);
			scenario = 'scenario3';
		} else if (scenario === 'scenario3') {
			// scenario3 but no KAM
			scenario = 'scenario2';
		}

		if (scenario == 'scenario2') {
			// replace email address
			const $priceOfferCard = $('#scenario2 .contact-card__item:nth-of-type(2)');
			const email = $priceOfferCard.data('mail-' + partner.kindServiceCode);
			const $emailElement = $priceOfferCard.find('.contact-card__email:first');

			setEmail($emailElement, email);
		}

		// render contact cards
		showScenarioCardList(scenario);
	}

	function validateInput($input, inputText) {
		const itemLabel = $input.closest('.item-label');

		if (!INPUT_REGEX.test(inputText)) {
			if (!inputText.length) itemLabel.addClass('is-filled');
			itemLabel.addClass('has-error');
			showErrorMessage($input, inputText);

			return false;
		}

		itemLabel.removeClass('has-error');
		removeErrorMessage($input);
		$input.trigger('blur');

		return true;
	}

	function showErrorMessage($input, inputText) {
		const message = !inputText.length ? EMPTY_FIELD : INVALID_FORMAT;

		if ($input.next('.inp__info').length) {
			$input.next('.inp__info').find('.item-icon .item-icon__text').text(message);
			return;
		}

		$input.after(inpInfoHTML(message));
	}

	function removeErrorMessage($input) {
		$input.next('.inp__info').remove();
	}

	function hideAll() {
		$contactCardItems.fadeOut();
	}

	function showScenarioCardList(scenario) {
		const scenarioId = `#${scenario}`;
		$(scenarioId).fadeIn();
		scrollToId(scenarioId);
	}

	function mapPartnersToScenarios(partners) {
		return partners.map(function (partner) {
			return {
				scenario: getScenario(partner),
				kindServiceCode: partner.KindServiceCode,
				kindService: partner.KindService,
				service: partner.Service,
			};
		});
	}

	function getScenario(partner) {
		if (!partner) {
			// not a customer
			return 'scenario4';
		}

		const scenario = kindServiceCodeToScenarioMappings[partner.KindServiceCode];
		return scenario ?? 'scenario2';
	}

	/**
	 * Sorts (in-place) partners based on scenario priority
	 * @param {Array} partners
	 */
	function sortPartners(partners) {
		partners.sort(function (partner1, partner2) {
			return scenarioPriorityList.indexOf(partner1.scenario) - scenarioPriorityList.indexOf(partner2.scenario);
		});
	}

	function fillManagerContactInfo(card, contactInfo) {
		const nameParts = [
			contactInfo.TitlePrefix1,
			contactInfo.TitlePrefix2,
			contactInfo.FirstName,
			contactInfo.SurName,
			contactInfo.TitleSuffix,
		];

		const name = nameParts.join(' ');

		card.find('.contact-card__subtitle').first().text(name);
		setEmail(card.find('.contact-card__email'), contactInfo.Email);
	}

	function setEmail($element, email) {
		if (!$element.length) return;

		$element.text(email);
		$element.attr('href', `mailto:${email}`);
	}

	function sendGTM(found) {
		dataLayer.push({
			event: 'formSubmitSuccess',
			formData: {
				formId: '9001',
				formType: 'Contact Form',
			},
			calcFields: { idNumberFound: found },
		});
	}

	const inpInfoHTML = (message) => `
		<span class="inp__info" role="alert">
			<span class="item-icon">
				<span class="item-icon__icon">
					<span class="icon-svg icon-svg--alert" aria-hidden="true">
						<svg class="icon-svg__svg" xmlns:xlink="http://www.w3.org/1999/xlink">
							<use xlink:href="/img/bg/icons-svg.svg#icon-alert" width="100%" height="100%" focusable="false"></use>
						</svg>
					</span>
				</span>
				<span class="item-icon__text">${message}</span>
			</span>
		</span>`;
};
